import { Text } from "@mantine/core"
import startCase from "lodash/startCase"
import { useTranslation } from "react-i18next"
import type { TCategoryName } from "@/types"
import { valueToThemeColor } from "../surveys"
import { icons } from "./icons"
import { TagBox, type TTagBoxProps } from "./Tags"

interface IProps extends TTagBoxProps {
  value: number
  active?: boolean
  category: TCategoryName
}

export function Metric({ value, category, active, ...props }: IProps) {
  const { t } = useTranslation()
  const CategoryIcon = icons[category]
  const color = `${valueToThemeColor(value!)}.9`
  return (
    <TagBox
      active={active !== undefined ? !active : undefined}
      key={category}
      variant={active ? "filled" : "outline"}
      color={active ? color : undefined}
      w={54}
      px={4}
      tooltip={startCase(t(category))}
      leftSection={<CategoryIcon size={10} stroke={2.2} />}
      onClick={(e) => {
        e.stopPropagation()
      }}
      {...props}
    >
      <Text c={active ? "white" : color} fz="xs" fw={700}>
        {(value! / 10).toFixed(1)}
      </Text>
    </TagBox>
  )
}
